import React, { useEffect, useState } from 'react'
import { Alert, Flex, Group, ScrollArea, Stack } from '@mantine/core'
import HeaderView from './common-header/HeaderView'
import HeaderViewV2 from './common-header-v2/HeaderViewV2'
import PaginatorComp from './paginator/PaginatorComp'
import './mainCommonView.scss'
import useResponsiveContent from '../../utils/hooks/useResponsiveContent'
import AppHeaderView from '../../component/layout/AppHeaderView.tsx'
import { themeCfg } from '../../theme/theme.ts'
import AppSection from '../../component/layout/AppSection.tsx'

const MainCommonView = ({
  header,
  subheader,
  headerOptions,
  headerOptionsV2,
  componentData,
  pagerOptions,
  disableAutoheight = false,
  version = 2,
}) => {
  useResponsiveContent(pagerOptions ? 48 : 0)

  if (version === 1)
    return (
      <Stack w="100%" gap={0}>
        <Group
          w="100%"
          h="50"
          justify="flex-end"
          pb="xs"
          align="center"
          className="main-common-view-header"
        >
          {headerOptions && <HeaderView {...headerOptions} />}
          {headerOptionsV2 && <AppHeaderView {...headerOptionsV2} />}
        </Group>

        <ScrollArea.Autosize m={0} p={0} className="main-common-view-content">
          {componentData}
        </ScrollArea.Autosize>

        {/* {pagerOptions && (
                <PaginatorComp {... pagerOptions} />
            )} */}
      </Stack>
    )

  return (
    <AppSection
      header={header}
      subheader={
        <>
          {subheader && subheader}
          {!subheader && headerOptions && <HeaderView {...headerOptions} />}
          {!subheader && headerOptionsV2 && (
            <AppHeaderView {...headerOptionsV2} />
          )}
        </>
      }
    >
      {componentData}
    </AppSection>
  )
}

export default MainCommonView
